import React from "react";
import { useDispatch } from "react-redux";

import { fetchNewDevices } from "../../../../../../store/devices/devices.actions";
import { RefreshButton } from "../../../../../../components/table/components";

export const DiscoveredDevicesInfo = () => {
  const dispatch = useDispatch();

  return <RefreshButton onClick={() => dispatch(fetchNewDevices())} />;
};
